/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum IncidentType {
    COMPROMISED_PAYMENT_INSTRUMENT = 'COMPROMISED_PAYMENT_INSTRUMENT',
    FRAUD = 'FRAUD',
    MSISDN_FRAUD = 'MSISDN_FRAUD',
    OTHER = 'OTHER'
}

